'use strict';

class HeaderController {

	constructor($scope, $mdDialog, $timeout) {
		
		this.$scope 		= $scope;
		this.$timeout 		= $timeout;
		this.mainTopCtrl 	= $scope.mainTopCtrl;
		this.resourcePath 	= this.$scope.DECISYON.template.resourcePath;
		this.$mdDialog 		= $mdDialog;
		this.delayTooltip 	= 1500;	
		this.onToggleSearchCallback = this.onToggleSearchCallback.bind(this);
		this.mainTopCtrl.attachOnChangeListener(() => {
			this._updateVM();
		});
		this._initializeVM();
	}

	isLogoActive() {
		return ENV_VARS.isApplicationLogoActive() && this.userButtonsInfo.homeLogo;
	}

	_setTaskBounce(isBounce) {
		this.mainTopCtrl.toTaskBounce = isBounce;
		this.toTaskBounce = isBounce ;
	}
	
	isTaskBounce() {
		return this.toTaskBounce;
	}
	
	_setNotificationBounce(isBounce) {
		this.mainTopCtrl.toNotificationBounce = isBounce;
		this.toNotificationBounce = isBounce ;
	}
	
	isNotificationBounce() {
		return this.toNotificationBounce;
	}
	
	_showProfileDialog(ev) {
		ev.stopPropagation();
		
    	this.$mdDialog.show({
            templateUrl: this.resourcePath + '/userDialog/user_dialog.template.html',
            clickOutsideToClose: true,
            hasBackdrop: false,
            targetEvent: ev,
            closeTo : '.dcy_main_header .dcy_user_icon',
            openFrom  : '.dcy_main_header .dcy_user_icon',
            controller: 'userDialogCtrl',
            controllerAs: 'userDialogCtrl',
            locals:{
            	userButtonsInfo : this.userButtonsInfo,
            	userInfo: this.userInfo,
            	mainTopCtrl : this.mainTopCtrl
            }
        });
    	
	}
	
	_toggleSideBar(ev){
		ev.stopPropagation();
		this.mainTopCtrl.toggleSideBar();
	}
	
	_onClickElement(buttonInfo, obj, ev) {
		ev.stopPropagation();
		this.mainTopCtrl.onClickElement(buttonInfo, obj, ev);
	}

	onToggleSearchCallback(isExpanded) {
		this.isSearchExpanded = isExpanded;
	}
	
	_openTasksManagement(ev){
		ev.stopPropagation();
		RouterAsyncBridge.getBridge().then((bridge) => {
			bridge.ROUTING_MANAGER.navigateToRoute(bridge.EROUTES.TASKS, '../dsh/dshPage.jsp.cas?revent=LW_DSH_LINK&dshID=991512029293749&csMLO=MASTERM');
		});
	}
	
	_initializeVM() {
		let _self = this;
		
		_self.data = _self.mainTopCtrl.data;
		_self.userButtonsInfo = _self.data.userButtonsInfo;
		_self.notifications = _self.userButtonsInfo.notifications;
		_self.task = _self.userButtonsInfo.task;
		_self.notificationsCount = _self.notifications.count;
		_self.taskCount = _self.task.count;
		_self.taskSecondCount = _self.task.secondCount;
		_self.hasExpiredTasks = (_self.task.secondCount && _self.task.secondCount > 0);
		_self.toNotificationBounce = _self.mainTopCtrl.toNotificationBounce;
		_self.toTaskBounce = _self.mainTopCtrl.toTaskBounce;
		_self.userInfo = _self.data.userInfo;
		_self.profile = _self.userButtonsInfo.profile;
		_self.viewBuildInfo = _self.userButtonsInfo.buildInfo.visible;
		_self.messages = _self.userButtonsInfo.messages;
		_self.searchTerms= "";
		_self.searchToolBarEnabled = !ENV_VARS.isSearchToolBarDisabled();
		_self.$timeout(function() {
			_self._setTaskBounce(false);
			_self._setNotificationBounce(false);
		}, 1200); // Il timeout è impostato ad un secondo per dare il tempo all'animazione di terminare. L'animazione dello shake dura 0.82 secondi
	}
	
	_updateVM () {
		this._initializeVM();		
	}
}
